(function () {
  const SECTION_SELECTOR = '[data-author-articles]';
  const EXTRA_SELECTOR = '[data-author-articles-extra][hidden]';
  const MAX_PAGES_PER_URL = 12;

  function revealHidden(root, batch) {
    const hidden = Array.prototype.slice.call(root.querySelectorAll(EXTRA_SELECTOR), 0, batch);

    hidden.forEach(function (item) {
      item.hidden = false;
      item.removeAttribute('data-author-articles-extra');
    });

    // Send focus into the first revealed card so keyboard users are not dropped back at the top.
    const firstLink = hidden.length ? hidden[0].querySelector('a[href]') : null;
    if (firstLink) firstLink.focus({ preventScroll: true });

    return hidden.length;
  }

  function seenHandles(root) {
    const set = new Set();
    root.querySelectorAll('[data-article-handle]').forEach(function (item) {
      set.add(item.dataset.articleHandle);
    });
    return set;
  }

  // Pulls the layout-free authorlist view of a tag archive — the store's own storefront, so no
  // API, no token and no CORS — and returns its cards plus the next page URL.
  function fetchArchivePage(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Archive responded ' + response.status);
        return response.text();
      })
      .then(function (html) {
        const holder = document.createElement('div');
        holder.innerHTML = html;

        const next = holder.querySelector('[data-authorlist-next]');
        return {
          items: Array.prototype.slice.call(holder.querySelectorAll('.aa-item')),
          next: next ? next.getAttribute('data-authorlist-next') : null,
        };
      });
  }

  function appendItems(grid, items, seen, hideFrom, counter) {
    let added = 0;

    items.forEach(function (item) {
      const handle = item.dataset.articleHandle;
      if (!handle || seen.has(handle)) return;
      seen.add(handle);

      counter.value += 1;
      if (hideFrom > 0 && counter.value > hideFrom) {
        item.hidden = true;
        item.setAttribute('data-author-articles-extra', '');
      }

      grid.appendChild(item);
      added += 1;
    });

    return added;
  }

  function loadArchive(root) {
    const grid = root.querySelector('.aa-items');
    const raw = root.dataset.archiveUrls;
    if (!grid || !raw) return Promise.resolve(0);

    const urls = raw.split(/\s+/).filter(Boolean);
    const seen = seenHandles(root);
    const hideFrom = parseInt(root.dataset.batchSize, 10) || 0;
    const counter = { value: root.querySelectorAll('[data-article-handle]').length };
    let added = 0;

    // Each blog is walked to the end of its pagination, so nothing is silently cut off.
    function walk(url, depth) {
      if (!url || depth >= MAX_PAGES_PER_URL) return Promise.resolve();

      return fetchArchivePage(url)
        .then(function (result) {
          added += appendItems(grid, result.items, seen, hideFrom, counter);
          return walk(result.next, depth + 1);
        })
        .catch(function (error) {
          console.warn('Author articles: archive fetch failed for ' + url, error);
        });
    }

    return urls
      .reduce(function (chain, url) {
        return chain.then(function () {
          return walk(url, 0);
        });
      }, Promise.resolve())
      .then(function () {
        return added;
      });
  }

  function syncUi(root) {
    const grid = root.querySelector('.aa-items');
    const empty = root.querySelector('.aa-empty');
    const button = root.querySelector('[data-author-articles-more]');
    const total = grid ? grid.querySelectorAll('[data-article-handle]').length : 0;
    const hiddenLeft = root.querySelectorAll(EXTRA_SELECTOR).length;

    if (total > 0 && empty) empty.remove();

    const counter = root.querySelector('.aa-count strong');
    if (counter && total > 0) counter.textContent = String(total);

    if (button && !hiddenLeft) button.remove();

    if (!button && hiddenLeft > 0) {
      // The server had nothing to hide, so the button has to be created for the fetched cards.
      const wrapper = document.createElement('div');
      wrapper.className = 'btns-wrapper aa-more';

      const created = document.createElement('button');
      created.type = 'button';
      created.className = 'more-btn button button--secondary';
      created.setAttribute('data-author-articles-more', '');
      created.dataset.batch = root.dataset.batchSize || '9';
      created.textContent = root.dataset.showMoreLabel || 'Show more articles';
      created.addEventListener('click', function () {
        revealHidden(root, parseInt(created.dataset.batch, 10) || 9);
        if (!root.querySelectorAll(EXTRA_SELECTOR).length) created.remove();
      });

      wrapper.appendChild(created);
      if (grid && grid.parentNode) grid.parentNode.insertBefore(wrapper, grid.nextSibling);
    }
  }

  function initSection(root) {
    if (root.dataset.authorArticlesInit === 'true') return;
    root.dataset.authorArticlesInit = 'true';

    const button = root.querySelector('[data-author-articles-more]');
    if (button) {
      const batch = parseInt(button.dataset.batch, 10) || 9;
      button.addEventListener('click', function () {
        revealHidden(root, batch);
        if (!root.querySelectorAll(EXTRA_SELECTOR).length) button.remove();
      });
    }

    if (root.dataset.archiveUrls) {
      loadArchive(root).then(function () {
        syncUi(root);
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
